export default __webpack_public_path__ + "static/media/facebook.50819230.svg";